/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import Popup from '@atlaskit/popup';
import { Box } from '@atlaskit/primitives/compiled';
import { layers } from '@atlaskit/theme/constants';
import UserPicker from '@atlaskit/user-picker';
import { type TeamOrUserPickerProps } from '../../types';
import TeamMemberPicker from './TeamMemberPicker';

const styles = cssMap({
	dummyPicker: {
		width: '354px',
		height: '44px',
	},
});

const TeamOrUserPicker = (props: TeamOrUserPickerProps) => {
	const clearTeamSelection = () => props.setSelectedTeam(undefined);
	const team = props.selectedTeam;

	return !team ? (
		<div data-testid="team-or-user-picker-wrapper">
			<UserPicker {...props} open />
		</div>
	) : (
		<div>
			<Popup
				onClose={clearTeamSelection}
				isOpen={true}
				content={() => (
					<TeamMemberPicker
						tenantId={props.tenantId}
						product={props.product}
						team={team}
						clearTeamSelection={clearTeamSelection}
					/>
				)}
				trigger={(triggerProps) => <div {...triggerProps} />}
				offset={[0, 4]}
				zIndex={layers.modal() + 1}
				placement="bottom-start"
			/>
			<Box xcss={styles.dummyPicker} />
		</div>
	);
};

export default TeamOrUserPicker;
